import type { KeyboardEvent } from 'react'

const IME_PROCESS_KEY_CODE = 229

// Safari fires the Enter that commits an IME conversion after
// compositionend, with isComposing false: only its keyCode marks it.
export function isComposingKeyDown(event: KeyboardEvent): boolean {
  return (
    event.nativeEvent.isComposing ||
    event.nativeEvent.keyCode === IME_PROCESS_KEY_CODE
  )
}
